var exports = {
  "Q": "x04b3a21e--0b16a2--link-button",
};

module.exports = exports;
